import React, { useState } from "react";
import { CalendarIcon } from "@heroicons/react/outline";
import Button from "./Button";

const DateRangePicker = ({ value, onChange, presets, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [customRange, setCustomRange] = useState({
    start: value?.start || new Date(),
    end: value?.end || new Date(),
  });

  const handlePresetClick = (preset) => {
    onChange(preset);
    setIsOpen(false);
  };

  const handleCustomRangeSubmit = () => {
    onChange({
      ...customRange,
      range: "custom",
      label: `${customRange.start.toLocaleDateString()} - ${customRange.end.toLocaleDateString()}`,
    });
    setIsOpen(false);
  };

  const formatDateForInput = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  return (
    <div className={`relative ${className}`}>
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2"
      >
        <CalendarIcon className="w-4 h-4" />
        {value?.label || "Select Date Range"}
      </Button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-80 bg-background dark:bg-glass-dark rounded-lg shadow-lg border border-neutral-light dark:border-neutral-dark z-20">
            <div className="p-4">
              <h3 className="font-medium text-text dark:text-neutral-light mb-3">
                Select Date Range
              </h3>

              {/* Preset Options */}
              <div className="space-y-1 mb-4">
                {Object.entries(presets || {}).map(([key, preset]) => (
                  <button
                    key={key}
                    onClick={() => handlePresetClick(preset)}
                    className="w-full text-left px-3 py-2 text-sm text-text dark:text-neutral-light hover:bg-neutral-light dark:hover:bg-glass-light rounded-md transition-colors"
                  >
                    {preset.label}
                  </button>
                ))}
              </div>

              <div className="border-t border-neutral-light dark:border-neutral-dark pt-4">
                <h4 className="text-sm font-medium text-text dark:text-neutral-light mb-3">
                  Custom Range
                </h4>
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs text-neutral-dark dark:text-neutral-light mb-1">
                      Start Date
                    </label>
                    <input
                      type="date"
                      value={formatDateForInput(customRange.start)}
                      onChange={(e) =>
                        setCustomRange({
                          ...customRange,
                          start: new Date(e.target.value),
                        })
                      }
                      className="w-full px-3 py-2 border border-neutral-light dark:border-neutral-dark rounded-md text-sm bg-background dark:bg-glass-dark text-text dark:text-neutral-light"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-neutral-dark dark:text-neutral-light mb-1">
                      End Date
                    </label>
                    <input
                      type="date"
                      value={formatDateForInput(customRange.end)}
                      onChange={(e) =>
                        setCustomRange({
                          ...customRange,
                          end: new Date(e.target.value),
                        })
                      }
                      className="w-full px-3 py-2 border border-neutral-light dark:border-neutral-dark rounded-md text-sm bg-background dark:bg-glass-dark text-text dark:text-neutral-light"
                    />
                  </div>
                  <Button
                    variant="primary"
                    size="sm"
                    fullWidth
                    onClick={handleCustomRangeSubmit}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DateRangePicker;
